export default function (_this) {
  return {
    create (data, callback) {
      let widgetKey
      // let dataKey

      function createWidget (resolve) {
        let newWidget = {
          template: '',
          gsOptions: {
            x: 0,
            y: 0,
            w: 5,
            h: 4
          },
          tab: data.tab
        }

        widgetKey = _this.getRef('widgets')
          .push(newWidget, (snapshot) => {
            resolve()
          }).key
      }

      function insertDeps () {
        return new Promise((resolve) => {
          _this.getRef('widgets/' + widgetKey + '/dependencies/pivottables')
            .set(widgetKey, () => {
              resolve()
            })
        })
      }

      function createWidgetData () {
        return new Promise((resolve) => {
          let tableData = {
            dataProviders: data.dataProviders
          }
          if (data.headers && data.headers.length) tableData.headers = data.headers
          _this.getRef('widgetsData/pivottables/' + widgetKey)
            .set(tableData, () => (resolve()))
        })
      }

      function fillTemplate () {
        _this.getRef('widgets/' + widgetKey + '/template')
          .set(`<PivotTable data-key="${widgetKey}" />`, () => {
            callback()
          })
      }

      let promise = new Promise((resolve) => {
        createWidget(resolve)
      })

      promise
        .then(() => {
          return insertDeps()
        })
        .then(() => {
          return createWidgetData()
        })
        .then(() => {
          fillTemplate()
        })
    },
    update (data, callback) {
      let promise = new Promise((resolve) => {
        _this.getRef('widgetsData/pivottables/' + data.table + '/dataProviders')
          .set(data.dataProviders, () => (resolve()))
      })

      promise.then(() => {
        if (data.headers && data.headers.length) {
          _this.getRef('widgetsData/pivottables/' + data.table + '/headers')
            .set(data.headers, () => (callback()))
        } else {
          _this.getRef('widgetsData/pivottables/' + data.table + '/headers')
            .remove(() => (callback()))
        }
      })
    },
    updateOptions (options, table) {
      _this.getRef('widgetsData/pivottables/' + table + '/options').set(JSON.stringify(options))
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/pivot-table.js